import { CrudList } from '../shared/CrudPage';
import { tenantDomainMapService, enumLabel } from '@kss/api';
import type { TenantDomainMap, TenantDomainMapCreate, TenantDomainMapFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllTenantDomainMaps() {
  return (
    <CrudList<TenantDomainMap, TenantDomainMapCreate, TenantDomainMapFilter>
      title="Tenant domains" newLabel="New mapping" service={tenantDomainMapService}
      idKey="tenantDomainMapId" labelKey="domain" basePath="/panel/tenant-domain-maps"
      columns={[
        { accessor: 'domain', title: 'Domain', sortable: true, filterable: true },
        { accessor: 'tenantId', title: 'Tenant', render: (r) => <NameCell kind="tenant" id={r.tenantId} /> },
        { accessor: 'isPrimary', title: 'Primary', sortable: true, render: (r) => r.isPrimary ? 'Yes' : '—' },
        { accessor: 'status', title: 'Status', sortable: true,
          render: (r) => <StatusBadge status={enumLabel('TenantDomainStatus', typeof r.status === 'number' ? r.status : Number(r.status))} /> },
      ]}
    />
  );
}
